import { UiVaultConfig } from 'src/@types/vaults';
import MarketIcon from '../Utils/MarketIcon';
import { useVaultAssetSymbols } from '../../hooks/vaults/useVaultAssetSymbols';

export const VaultManagerIcon = ({
	uiVaultConfig,
	size = 24,
	assetSize,
	showTradedMarkets,
}: {
	uiVaultConfig: UiVaultConfig;
	size?: number;
	assetSize?: number;
	showTradedMarkets?: boolean;
}) => {
	const vaultAssetSymbols = useVaultAssetSymbols(
		uiVaultConfig.vaultPubkeyString
	);

	const assetSizeToUse = assetSize ?? size / 2;

	return (
		<div className="relative">
			<img
				src={uiVaultConfig.vaultManager.imgSrc}
				alt={uiVaultConfig.name}
				style={{
					width: size,
					height: size,
					minWidth: size,
					minHeight: size,
					borderRadius: 4,
				}}
			/>
			{showTradedMarkets &&
				vaultAssetSymbols.map((symbol, index) => (
					<MarketIcon
						key={symbol}
						marketSymbol={symbol}
						style={{
							width: assetSizeToUse,
							height: assetSizeToUse,
							right: index * (assetSizeToUse / 2) - 4,
							bottom: -4,
							zIndex: vaultAssetSymbols.length - index,
						}}
						className="absolute bottom-0"
					/>
				))}
		</div>
	);
};
